import React, { useContext } from 'react';
import { RowsGroups, RowsGroupsAction } from 'common/reducers/rowsGroups/types';
import { FieldAttribute } from 'common/types/store';
import { IMeasurementDate } from 'models/interfaces/measurement-date.interface';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

export interface Scope {
  [sheetName: string]: { [key: string]: ICell }[];
}

export interface CapTableContextType {
  measurementDate: string | undefined;
  selectedMeasurementDate: IMeasurementDate;
  rowGroups: RowsGroups;
  setRowGroups: React.Dispatch<RowsGroupsAction>;
  isDisabled: boolean;
  cells: Scope;
  getLinkedCellUpdates: any;
  convertibleNotesFieldAttrs: FieldAttribute;
  hasVariableLiquidationPreference: boolean;
  setHasVariableLiquidationPreference: React.Dispatch<React.SetStateAction<boolean>>;
  hasVariableDividendRate: boolean;
  setHasVariableDividendRate: React.Dispatch<React.SetStateAction<boolean>>;
  divRateLedgerItemAttrs: FieldAttribute;
}

const CapTableContext = React.createContext<CapTableContextType>({
  measurementDate: undefined,
  selectedMeasurementDate: {
    name: '',
    date: '',
    cmd_id: 0,
  },
  rowGroups: {},
  setRowGroups: () => {},
  isDisabled: false,
  cells: {},
  getLinkedCellUpdates: () => {},
  convertibleNotesFieldAttrs: {},
  hasVariableLiquidationPreference: false,
  setHasVariableLiquidationPreference: () => {},
  hasVariableDividendRate: false,
  setHasVariableDividendRate: () => {},
  divRateLedgerItemAttrs: {},
});

export const useCapTableContext = () => useContext(CapTableContext);

export default CapTableContext;
